import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';

@AutoUnsubscribe()
@Component({
  selector: 'onboarding-form-notes-widget',
  templateUrl: './onboarding-form-notes-widget.component.html',
  styleUrls: ['./onboarding-form-notes-widget.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingFormNotesWidgetComponent implements OnInit {
  @Output() passFieldDataEvent = new EventEmitter<any>();
  @Input() data;
  @Input() index;
  note;
  constructor(private cd: ChangeDetectorRef) {}

  ngOnInit(): void {}
  checkNote(e) {
    this.passFieldDataEvent.next({
      index: this.index,
      note: e.trim(),
    });
    this.note = e.trim();
    this.cd.detectChanges();
  }
}
